<template>
    <div class="container">
        <div style="text-align:center; font-size:20px; font-weight:700;">글쓴이, 출처, 작성일, 논리를 찾아 확인해주세요.</div>

        <div style="display:flex;">
            <div class="flex_item">
                <div style="text-align:center; font-size:20px; font-weight:700; color:#64ACF8;">신뢰할 수 있는 근거</div>
                <transition-group name="fade">
                    <div v-for="item in checkSlotTrue" :key="item.key" style="padding:5px; margin:5px;">
                        <div style="font-weight:700; font-size:15px;">{{item.key}}</div>
                        <div style="color:white; background-color:#64ACF8; font-size:15px; padding:2px;"> - {{displayType(item.type)}}: {{item.desc}}</div>
                    </div>
                </transition-group>
            </div>
            <div class="flex_item">
                <div style="text-align:center; font-size:20px; font-weight:700; color:#ED5750;">신뢰할 수 없는 근거</div>
                <transition-group name="fade">
                    <div v-for="item in checkSlotFalse" :key="item.key" style="padding:5px; margin:5px;">
                        <div style="font-weight:700; font-size:15px;">{{item.key}}</div>
                        <div style="color:white; background-color:#DF5D5B; font-size:15px; padding:2px;"> - {{displayType(item.type)}}: {{item.desc}}</div>
                    </div>
                </transition-group>
            </div>
        </div>

        <div class="btn_container">
            <div v-if="showChooseButton" class="btn_choose_clue" @click="chooseClue">근거 채택하기</div>
            <div v-else class="btn_choose_clue_disable" >근거 채택하기</div>
            <div class="btn_other_clue" @click="next">다른 근거 선택하기</div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ClueCheckSlotComp',

    props: {
        checkSlotTrue: Array,
        checkSlotFalse: Array,
        clueItemsGameData: Object,
        currentCluePlayerData: Object
    },

    data() {
        return {
            // showChooseButton: false
            highlightsCount: -1,
        }
    },

    mounted() {
        // this.checkSlotTrue = []
        // this.checkSlotFalse = []

        console.log('ClueCheckSlotComp#mounted')
        // 이전에 풀던 내용을 불러와서 처리한다
        const highlights = document.getElementsByClassName('highlight')
        this.highlightsCount = highlights.length
        console.log('ClueCheckSlotComp#mounted: highlightsCount: ' + this.highlightsCount)
        
        // console.log('this.currentCluePlayerData')
        // console.log(this.currentCluePlayerData)
        for(let light of highlights) {
            for(let item of this.currentCluePlayerData.items) {
                // TODO 근거에 처음으로 들어왔을 때 key 에러를 내는 듯 함
                // console.log('clueItemsGameData')
                // console.log(this.clueItemsGameData)
                // console.log('item')
                // console.log(item)
                if(this.clueItemsGameData[item].key != undefined) {
                    if(light.innerHTML == this.clueItemsGameData[item].key) {
                        this.clueItemsGameData[item].dom = light
                        if(this.clueItemsGameData[item].result == 'TRUE') {
                            this.clueItemsGameData[item].dom.style.backgroundColor = '#64ACF8'
                            this.checkSlotTrue.push(this.clueItemsGameData[item])
                        }
                        else {
                            this.clueItemsGameData[item].dom.style.backgroundColor = '#DF5D5B'
                            this.checkSlotFalse.push(this.clueItemsGameData[item])
                        }
                    }
                }
            }
        }
    },

    computed: {
        showChooseButton: function() {
            // 모든 item이 적합하다면 근거 선택 버튼이 활성화
            if(this.highlightsCount == this.checkSlotTrue.length + this.checkSlotFalse.length) {
                // this.showChooseButton = true
                return true
            }
            return false;
        },
    },

    methods: {
        next: function() {
            this.$router.push('/clueList3')
        },
        chooseClue: function() {
            this.$emit('chooseClue')
        },
        displayType: function(t) {
            if(t == '시의성') {
                return '작성일'
            }
            else if(t == '저자') {
                return '글쓴이'
            }
            else if(t == '논리') {
                return '설명/논리'
            }
            else if(t == '출처') {
                return '출처'
            }
            else {
                return ''
            }
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    overflow: auto;

    margin:10px 0px;

    width: 550px;
    height: 470px;
}
.flex_item {
    padding:10px 30px;
    padding:10px;

    border:black solid 1px;
    margin:10px;
    background-color: white;

    width:260px;
    height: 348px;

    overflow: auto;
    box-shadow: 0px 3px 3px grey;
}

.fade-enter-active, .fade-leave-active {
    transition: all 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(50px);
}

.btn_other_clue {
    text-align: center;
    width: 220px;

    padding: 10px;
    margin: 0px 5px;

    border: 2px solid black;
    box-shadow:3px 3px 3px grey;

    font-weight: 700;
    font-size: 20px;
    color: black;

    cursor:pointer;
    background-color: white;
}
.btn_choose_clue {
    text-align: center;
    width: 220px;

    padding: 10px;
    margin: 0px 5px;

    border: 2px solid black;
    box-shadow:3px 3px 3px grey;

    font-weight: 700;
    font-size: 20px;
    color: white;

    cursor:pointer;
    background-color: black;
}
.btn_choose_clue_disable {
    text-align: center;
    width: 220px;
    padding: 10px;
    margin: 0px 5px;
    border: 1px solid gray;
    font-weight: 700;
    font-size: 20px;
    color: white;
    background-color: lightgray;
}
.btn_container {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
